import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from '../../../../context/API';
import { notification } from '../../../../commonComponents/Notification/Notification';
import { SoldOutOption } from '../types';
import { QUERY_KEYS } from '../constants';

export function useMarkOptionAvailable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (option: SoldOutOption) =>
      API.put(`/options/${option.id}`, {
        option: option.option,
        description: option.description,
        price: option.price,
        sequence_number: option.sequence_number,
        customization: option.customization,
        sold_out: false,
      }),
    onSuccess: () => {
      notification.success('Option status updated', 'The option is now available.', 5);
    },
    onError: () => {
      notification.error('An error occurred', 'Unable to update the option.', 5);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SOLD_OUT_OPTIONS] });
    },
  });
}
